export default __webpack_public_path__ + "static/media/l1.09f2afd5.jpg";